var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"c-picture picture",class:{
    'picture--fit': !_vm.isImg,
  },attrs:{"data-animation":_vm.lazy && _vm.isAnimated ? 'picture' : false}},[_c('div',{staticClass:"picture__mask"},[_c('img',{staticClass:"picture__img",attrs:{"data-src":_vm.lazy ? _vm.data.src : null,"src":!_vm.lazy ? _vm.data.src : null,"alt":_vm.data.alt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }